module.exports = __webpack_public_path__ + "img/BAK_780_thumb.6f8fb291.jpg";